import { Anchor, Group, Text } from '@mantine/core';

import env from '@config/env';

interface FooterProps {
  innerRef?: React.LegacyRef<HTMLElement>;
}

export default function Footer({ innerRef }: FooterProps) {
  // ==========================================================================
  // Render
  // ==========================================================================
  return (
    <footer ref={innerRef}>
      <Group py={{ base: 'xl', md: 'sm' }} justify="space-between">
        <Group>
          <Text size="xs" c="dimmed">
            v{env.APP_VERSION}
          </Text>
        </Group>
        <Text size="xs">
          Developed by{' '}
          <Anchor
            size="xs"
            href="https://www.miroirstudio.com"
            target="_blank"
            rel="noopener noreferrer"
          >
            Miroir Studio
          </Anchor>
        </Text>
      </Group>
    </footer>
  );
}
